import { FC } from "react";
import styles from "./description.module.scss";
import StringToHtmlTransformer from "../../common-components/string-to-html-transformer";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import { getTranslationModule } from "../../../utils/translations";
import VDPSection from "@/ui/page-components/vehicle-details-page/vdp-section";

const Description: FC<IVDPPageBlock> = ({ vdpGlobalData, translations }) => {
  const t = getTranslationModule(translations, "vdp");

  const vehicle = vdpGlobalData.vehicle;
  if (!vehicle.description) {
    return null;
  }

  const htmlLayout = vehicle.description.replace(/&nbsp;/g, " ");

  return (
    <VDPSection title={t("vehicle_description")} subtitle={`${vehicle.make} ${vehicle.model} ${vehicle.trim}`}>
      <StringToHtmlTransformer className={styles.content} layout={htmlLayout} />
    </VDPSection>
  );
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <Description
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
